<template>
    <div class="toggle-wrapper">
        <label class="switch">
            <input v-model="localValue" type="checkbox" :class="{ 'is-invalid': errorMessage }" @change="handleChange">
            <span class="slider"></span>
        </label>
        <div v-if="errorMessage" class="invalid-feedback">{{ errorMessage }}</div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    modelValue: {
        type: [Boolean, String, Number, null],
        default: true
    },
    errors: {
        type: Object,
        default: () => ({})
    },
    errorFieldName: {
        type: String,
        default: ''
    }
});

const emit = defineEmits(['update:modelValue', 'toggle']);

const localValue = computed({
    get() {
        return Boolean(props.modelValue); // 🔹 Convierte cualquier valor a `true` o `false`
    },
    set(value) {
        emit('update:modelValue', value);
    }
});

const errorMessage = computed(() => {
    return props.errors[props.errorFieldName] ? props.errors[props.errorFieldName][0] : null;
});

const handleChange = (event) => {
    const newValue = event.target.checked;
    emit('update:modelValue', newValue); // 🔹 Emite solo `true` o `false`
    emit('toggle', newValue);
};

</script>

<style scoped>
/* Switch minimalista, pequeño y moderno */
.toggle-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
}

.switch {
    position: relative;
    display: inline-block;
    width: 36px;
    height: 20px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #e5e7eb;
    transition: background 0.2s;
    border-radius: 999px;
}

.slider:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 3px;
    top: 3px;
    background: #fff;
    border-radius: 50%;
    transition: transform 0.2s;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

input:checked+.slider {
    background: #007bff;
}

input:checked+.slider:before {
    transform: translateX(16px);
}

input:focus+.slider {
    box-shadow: 0 0 0 2px #b6d4fe;
}

.is-invalid+.slider {
    border: 1.5px solid #dc3545;
}

.invalid-feedback {
    color: #dc3545;
    font-size: 0.78rem;
    margin-top: 2px;
}
</style>
